"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBackupServicingCycleMetricsParams = void 0;
const createBackupServicingCycleMetricsParams = () => {
    // No params required: the servicing cycle to render is identified by the
    // worklease's servicingCycleId at runtime. Can extend as needed.
    return {
        isValid: true,
        params: null,
    };
};
exports.createBackupServicingCycleMetricsParams = createBackupServicingCycleMetricsParams;
//# sourceMappingURL=backupServicingCycleMetricsParams.js.map